import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action, toJS} from 'mobx';
import Modal from '../../Modal';
import Spinner from '../../Spinner';
import Form, {FormBody, FormActions, SelectInput, TextInput} from '../../Form';
import CronIntervalInput from "../../CronIntervalInput";
import {timezones} from "../../../libs/date";

@inject('imageSourceStore')
@observer
class ImageSourceAdd extends Component {
  static propTypes = {
    route: PropTypes.object.isRequired,
    imageSourceStore: PropTypes.object.isRequired,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  }

  @observable item = {
    name: '',
    protocol: '',
    address: '',
    user_name: '',
    password: '',
    interval: '*/10 * * * *',
    timezone: '+00:00'
  };

  slug = '/idaq/image_source';
  title = 'Add Image Source';

  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
  }

  @action onChangeItem = (key, value) => this.item[key] = value;

  handleSave(e) {
    e.preventDefault();

    const {imageSourceStore} = this.props;
    const {notify} = this.context;

    imageSourceStore.createItem(this.item)
      .then(() => {
          notify.success({message: 'Success'});
          this.context.router.push(this.slug);
      })
      .catch(err => {
        notify.error(err);
      });
  }

  render() {
    const {imageSourceStore} = this.props;

    return (
      <Modal title={this.title} slug={this.slug} isSaving={imageSourceStore.isSaving} handleSave={this.handleSave}>
        {imageSourceStore.isLoading ? <Spinner/> : <Form>
          <FormBody>
            <TextInput label={'Name'} value={this.item.name} onChange={e => this.onChangeItem('name', e.target.value)}/>
            <SelectInput
              label={'Protocol'}
              value={this.item.protocol}
              onChange={e => this.onChangeItem('protocol', e.target.value)}
              options={imageSourceStore.protocolOptions}
              fields={{value: 'id', label: 'name'}}
            />
            <SelectInput
              label={'Timezone'}
              fields={{ label: 'offset', value: 'offset' }}
              options={timezones}
              onChange={e => this.onChangeItem('timezone', e.target.value)}
              value={this.item.timezone}
            />
            <TextInput label={'Address'} value={this.item.address} onChange={e => this.onChangeItem('address', e.target.value)}/>
            <TextInput label={'User Name'}value={this.item.user_name} onChange={e => this.onChangeItem('user_name', e.target.value)}/>
            <TextInput label={'Password'} value={this.item.password} onChange={e => this.onChangeItem('password', e.target.value)}/>

            <CronIntervalInput label={'Interval'} value={this.item.interval} onChange={e => this.onChangeItem('interval', e.target.value)}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>}
      </Modal>
    );
  }
}

export default ImageSourceAdd;


// WEBPACK FOOTER //
// ./src/components/IDaq/ImageSource/ImageSourceAdd.js